import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { ReduxSpinner, ReduxSelectField } from '../ReduxInput/ReduxInput';
import {  isRequired } from '../ReduxInput/Validators';
import { Row, Col, Button, FormGroup, Label, Form } from 'reactstrap';

class UpdateForm extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      operator: null,
      value: null
    };

  }



  render(){
    let values = [
      {
        text: "+/- by Percent",
        value: "PERCENT"
      },
      {
        text: "+/- by Amount",
        value: "DOLLAR"
      },
    {
        text: "Set Rate",
        value: "BULK_SET"
      }
    ];

    return (
      <Form onSubmit={this.props.handleSubmit}>
        <FormGroup>
          <Label >Modifications</Label>
          <Row>
          <Col md="5">
          <Field
            placeholder={"Select Modification"}
            name={"operator"}
            values={values || ["Empty"]}
            component={ReduxSelectField}
            validate={isRequired}
          />
          </Col>
          <Col md="5">
          <Field
            placeholder={"Select Value"}
            name={"number"}
            values={values || ["Empty"]}
            min={-10000}
            max={10000}
            component={ReduxSpinner}
            validate={isRequired}
          />
          </Col>
          <Col md="1">
              <Button type="submit" className="btn btn-success">Preview</Button>
            </Col>
          </Row>
        </FormGroup>     
      </Form>
    );
  }
}




export default reduxForm({
  form: 'UpdateForm',// a unique identifier for this form 
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: true,
  enableReinitialize: true
})(UpdateForm);


// WEBPACK FOOTER //
// ./src/components/RateManagment/UpdateForm.js